import type { ICourse, IUserCourse, TItem } from "~/types/course";

export default function useCourse() {
  const { $api } = useNuxtApp()

  const courseId = useState('active-course-id', (): null|string => localStorage.getItem('active_course_id'))
  const course = useState<IUserCourse | null>('active-course', () => null)
  const activeItem = useState<TItem | null>('active-item', () => null)

  const watched = computed(() => {
    if (!course.value?.watched) return [];

    return course.value.watched
  })

  const activeIndex = computed(() => {
    return course.value?.lastIndex ?? 0
  })

  const isWatched = (id: number) => {
    if (course.value) return watched.value.includes(id);

    return false;
  };

  const setCourseId = (id: number | string | null) => {
    if (id === null) {
      localStorage.removeItem('active_course_id')
      courseId.value = null;
    } else {
      localStorage.setItem('active_course_id', id.toString())
      courseId.value = id.toString()
    }
  }

  const setCourses = (data: IUserCourse) => {
    course.value = data
  }

  const updateItem = (item: TItem, globalIndex: number): boolean => {
    let changed = false

    if (!course.value) return changed

    if (item.id !== activeItem.value?.id) {
      course.value.lastIndex = globalIndex
      changed = true
    } else {
      course.value.time = item.start
    }

    return changed
  }

  const setActiveItem = (item: TItem) => {
    activeItem.value = item
  }

  let logInProcess = false
  const logPlayer = async (data: { percent: number, time: number }) => {
    if (!course.value) throw new Error('Course is not set')
    if (logInProcess) return // skip if a previous log call hasn't finished yet

    logInProcess = true

    try {
      await $api(`/edu/user/courses/${course.value.id}/activity/${activeIndex.value}`, {
        method: 'patch',
        body: {
          percent: data.percent,
          time: data.time,
          itemId: activeItem?.value?.id,
        }
      })
    } catch (e) {
      console.warn('logPlayer failed', e)
    } finally {
      logInProcess = false
    }
  }

  const fetchCourse = async (slug: string): Promise<ICourse> => {
    return await $api<ICourse>(`/edu/courses/${slug}`)
  }

  const downloadAttachment = async (type: 'item' | 'package', index: number) => {
    let path = `/edu/courses/${course.value?.id}/attachments/${index}/download`
    if (type === 'item') {
      path = `/edu/courses/${course.value?.id}/items/${activeIndex.value}/attachments/${index}/download`
    }

    try {
      const { url } = await $api<{ url: string }>(path)

      return url
    } catch (e) {
      throw new Error('خطا در دریافت لینک دانلود')
    }
  }

  return {
    course,
    setCourseId,
    courseId,
    setCourses,
    activeItem,
    setActiveItem,
    logPlayer,
    fetchCourse,
    isWatched,
    downloadAttachment,
    updateItem,
    watched,
    activeIndex
  }
}